import moment from 'moment-timezone';

export const DATE_DDMM_REGEX = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])$/;
export const AVATAR_ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const AVATAR_MAX_SIZE_BYTES = 2 * 1024 * 1024;

export const createEmptyValidationState = () => ({
  isValid: true,
  errors: {
    timezone: '',
    weather: '',
    sessionLength: '',
    intClocks: [],
    celebrations: [],
    avatar: '',
  },
});

const hasAnyRowErrors = (rows) =>
  rows.some((row) => Object.values(row).some((value) => value && value !== ''));

const isValidLatitude = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric >= -90 && numeric <= 90;
};

const isValidLongitude = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric >= -180 && numeric <= 180;
};

const isPositiveInteger = (value) => {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  const numeric = Number(value);
  return Number.isInteger(numeric) && numeric > 0;
};

export const validateSettings = (settingsState) => {
  const validation = createEmptyValidationState();
  const { errors } = validation;

  if (!settingsState.timezone || !moment.tz.zone(settingsState.timezone)) {
    errors.timezone = 'Please choose a valid timezone.';
  }

  const hasCitySelection = (settingsState.weather.cityLabel || '').trim().length > 0;
  if (!hasCitySelection || !isValidLatitude(settingsState.weather.lat) || !isValidLongitude(settingsState.weather.lon)) {
    errors.weather = 'Please search and select a city so latitude and longitude are valid.';
  }

  if (!isPositiveInteger(settingsState.sessionLength)) {
    errors.sessionLength = 'Session length must be a positive integer (minutes).';
  }

  errors.intClocks = (settingsState.intClocks || []).map((clock) => {
    const rowError = { city: '', timezone: '' };
    if (!clock || !(clock.city || '').trim()) {
      rowError.city = 'City is required.';
    }
    if (!clock || !clock.timezone || !moment.tz.zone(clock.timezone)) {
      rowError.timezone = 'Valid timezone is required.';
    }
    return rowError;
  });

  errors.celebrations = (settingsState.celebrations || []).map((celebration) => {
    const rowError = { date: '', title: '' };
    if (!celebration || !(celebration.title || '').trim()) {
      rowError.title = 'Title is required.';
    }
    if (!celebration || !DATE_DDMM_REGEX.test((celebration.date || '').trim())) {
      rowError.date = 'Date must match DD/MM.';
    }
    return rowError;
  });

  if (settingsState.avatarFile) {
    const { type, size } = settingsState.avatarFile;
    if (!AVATAR_ALLOWED_MIME_TYPES.includes(type)) {
      errors.avatar = 'Avatar must be JPEG, PNG, or WEBP.';
    } else if (size > AVATAR_MAX_SIZE_BYTES) {
      errors.avatar = 'Avatar must be 2MB or smaller.';
    }
  }

  validation.isValid =
    !errors.timezone &&
    !errors.weather &&
    !errors.sessionLength &&
    !errors.avatar &&
    !hasAnyRowErrors(errors.intClocks) &&
    !hasAnyRowErrors(errors.celebrations);

  return validation;
};
